class ConfigNotificacoesController {
    constructor($scope, $modalInstance, api) {
        this.apply = (fn) => $scope.$apply(fn)

        this.modalInstance = $modalInstance
        this.api = api
        this.config = null

        this.tiposAlerta = [
            { id: "site", descricao: "Site" },
            { id: "email", descricao: "E-mail" }
        ]

        this.tipos = [
            { id: "importacao_codigos_fornecedores", descricao: "Importação de códigos de fornecedores" },
            { id: "importacao_zip_nfe", descricao: "Importação de ZIP de NF-e" },
            { id: "nfe_cancelada", descricao: "NF-e canceladas" },
            { id: "nfe_comentario_adicionado", descricao: "Comentário adicionado na NF-e" },
            { id: "nfe_manifestacao", descricao: "Manifestação de NF-e" },
            { id: "nfe_manifestos_pendentes", descricao: "Manifestos de NF-e pendentes" },
            { id: "vencimento_certificado", descricao: "Certificados expirados ou prestes a vencer" },
            { id: "coletor_xml", descricao: "Notificações referentes ao coletor de XML" }
        ]

        this.loadingPromise = this.init()
    }

    async init() {
        let { data: { config } } = await this.api.get('/notificacoes/config');

        this.tipos.map(t => t.id).forEach(k => {
            if (!config[k]) config[k] = { site: true, email: false }
        })

        this.apply(() => this.config = config)
    }

    async save() {
        this.saving = true

        let { status } = await this.api.put('/notificacoes/config', { config_usuario: this.config })

        if (status === 204)
            this.close()
        else
            this.saving = false
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular.module('eficienciaFiscalModule').controller('configNotificacoesController', ['$scope', '$uibModalInstance', 'api', ConfigNotificacoesController])
